export default {
    colors: {
        primary: '#4500FF',
        secondary: '#4500FF',
        titles: '#1D006C',
        hover: '#3B00D9',
        inactive: '#A280FF'
    },
    overrideFunction: ({ colors }) => ({
        fontStackCommon: "'Omnes', 'Arial', sans-serif",
        fontStackHeadings: "'Omnes', 'Arial', sans-serif",

        boldTextColor: colors.titles,
        h1Color: colors.titles,
        h1BorderColor: colors.primary,
        h2Color: colors.titles,
        h2BorderColor: colors.primary,
        h3Color: colors.titles,
        hXColor: colors.titles,
        colorLink: colors.secondary,
        subNavBg: colors.secondary,
        subNavMobileBackgroundColor: colors.secondary,
        partnerOfferMain: colors.primary,
        partnerCardMainDiscountColor: colors.primary,
        howItWorkBlockBoldColor: colors.primary,
        faqLinkTextColor: colors.black,
        hrBackgroundColor: colors.primary,

        buttonMainBg: colors.secondary,
        buttonMainText: colors.white,
        buttonMainBorder: colors.secondary,
        buttonMainHoverBg: colors.hover,
        buttonMainHoverText: colors.white,
        buttonMainHoverBorder: colors.hover
    })
};



// WEBPACK FOOTER //
// ./src/style/applicationSpecific/shopopopTheme.js